var styles = {"loader":"LuminateLoader-module_loader__n54-8","l1":"LuminateLoader-module_l1__D63AC","image":"LuminateLoader-module_image__I1fSP","flexDir":"LuminateLoader-module_flexDir__TXtKt","center":"LuminateLoader-module_center__9N9P2","backgroundBlur":"LuminateLoader-module_backgroundBlur__ve5WT"};

export { styles as default };
